import {useState, useEffect} from 'react';
import {TabPane, Table} from 'reactstrap';

import {KeyValuePair} from 'src/types';
import {getActuatorInfo} from 'src/api/actuator';
import {flattenObject} from 'src/util/helpers';
import {NoRecords} from 'src/components';

import './administration.css';

const AppInfo = ({setLoading}: {setLoading: (_:boolean) => void}) => {
  const [configData, setConfigData] = useState<Array<KeyValuePair>>([]);

  useEffect(() => {
    fetchInfo();
  }, []);

  const fetchInfo = async () => {
    setLoading(true);
    let {data} = await getActuatorInfo();
    setLoading(false);
    if (data) {
      data = flattenObject(data);
      const keyValueArray: Array<KeyValuePair> = [];
      for (const [key, value] of Object.entries(data)) {
        const object: KeyValuePair = {key: key, value: value};
        keyValueArray.push(object);
      }
      setConfigData(keyValueArray);
    }
  };

  return (
    <TabPane tabId="6">
      <div className="app-info-tab">
        <Table hover responsive>
          <thead>
            <tr>
              <th>Key</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {configData.length > 0 ? configData.map((config, i) => (
              <tr key={i}>
                <td>{config.key}</td>
                <td>{config.value}</td>
              </tr>
            )) : <NoRecords />}
          </tbody>
        </Table>
      </div>
    </TabPane>
  );
};

export default AppInfo;
